var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }\n  .spinner { animation: spin 1s linear infinite; transform-origin: 12px 12px; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9995 12C20.9995 16.9706 16.9701 21 11.9995 21C7.02895 21 2.99951 16.9706 2.99951 12C2.99951 7.02944 7.02895 3 11.9995 3C16.9701 3 20.9995 7.02944 20.9995 12ZM5.51951 12C5.51951 15.5788 8.42071 18.48 11.9995 18.48C15.5783 18.48 18.4795 15.5788 18.4795 12C18.4795 8.42119 15.5783 5.52 11.9995 5.52C8.42071 5.52 5.51951 8.42119 5.51951 12Z",
    fill: "var(--spinner-track, #BCBDC3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "spinner",
    d: "M11.9995 3C13.1814 3 14.3517 3.23279 15.4437 3.68508C16.5356 4.13738 17.5277 4.80031 18.3635 5.63604C19.1992 6.47177 19.8621 7.46392 20.3144 8.55585C20.7667 9.64778 20.9995 10.8181 20.9995 12L18.4795 12C18.4795 11.149 18.3119 10.3064 17.9863 9.52021C17.6606 8.73402 17.1833 8.01967 16.5816 7.41795C15.9798 6.81622 15.2655 6.33891 14.4793 6.01326C13.6931 5.68761 12.8505 5.52 11.9995 5.52V3Z",
    fill: "var(--spinner-arc, #4A304A)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadInProgress);
export default __webpack_public_path__ + "static/media/downloadInProgress.0a72fe1f1283604d21d74916fe30f898.svg";
export { ForwardRef as ReactComponent };